import {
    BreadcrumbItem,
    Breadcrumbs,
} from "@design-system/Breadcrumbs/Breadcrumbs";

/** Template drawer title: "{title} > {template name}", or just the title before the template loads. */
export const TemplateDrawerTrail = ({
    title,
    templateName,
}: {
    title: string;
    templateName?: string;
}) => (
    <Breadcrumbs>
        {templateName === undefined ? (
            <BreadcrumbItem current>{title}</BreadcrumbItem>
        ) : (
            <>
                <BreadcrumbItem>{title}</BreadcrumbItem>
                <BreadcrumbItem current>{templateName}</BreadcrumbItem>
            </>
        )}
    </Breadcrumbs>
);
